/* ============================================================
   Thin GA4 (gtag) event wrapper.
   No-ops during SSG or before the gtag library loads. The inline snippet in
   index.html defines window.gtag synchronously, so events fired early queue in
   the dataLayer and flush once the library arrives — nothing is lost.

   Usage:  import { track } from '../lib/analytics.js'
           track('save_calculation', { peptide: name })

   Recommended custom events (GA4 → Admin → Events, then toggle "Mark as
   conversion" on the ones that matter): sign_up, save_calculation, copy_embed.
   ============================================================ */
export function track(event, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  try {
    window.gtag('event', event, params)
  } catch {
    /* analytics must never break the app */
  }
}

// TikTok Pixel event (e.g. 'CompleteRegistration' on signup). No-op until the
// pixel is configured in index.html; the stub always exists so this is safe.
export function ttrack(event, params = {}, options) {
  if (typeof window === 'undefined' || !window.ttq || typeof window.ttq.track !== 'function') return
  try {
    // options.event_id lets TikTok dedupe this pixel event against the matching
    // server-side (Events API) event that carries the same id.
    options ? window.ttq.track(event, params, options) : window.ttq.track(event, params)
  } catch {
    /* analytics must never break the app */
  }
}
